import React, { useState, useEffect } from 'react';
import { Input, Image, DatePicker, Radio, Select, Button, Slider, Switch, InputNumber,App, Table, Upload, UploadProps, UploadFile, GetProp, Modal } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { eventBus } from '@/utils/eventBus';
import styles from './index.module.scss';
import dayjs from 'dayjs';
import liveIcon1 from '@/assets/images/live-icon1.png';
import { useNavigate } from 'react-router-dom';
import{ liveRoomGetLiveRoomPageList, liveRoomSaveScheduleLiveRoom } from '@/api/products';
import { useTranslation } from 'react-i18next';

const GoLiveNow: React.FC = () => {
  const dispatch = useAppDispatch();
  const { message } = App.useApp();
  const navigate = useNavigate();
  // 直播表单状态
  const [liveTitle, setLiveTitle] = useState('');
  const [liveStartTime, setLiveStartTime] = useState<any>(null);
  const [liveEndTime, setLiveEndTime] = useState<any>(null);
  const [audioSwitch, setAudioSwitch] = useState(true);
  const [videoSwitch, setVideoSwitch] = useState(true);
  const [productShowcase, setProductShowcase] = useState(true);
  const [beautyTool, setBeautyTool] = useState(true);
  const [tab, setTab] = useState(0);
  // 美颜功能状态
  const [skinSmoothing, setSkinSmoothing] = useState(0);
  const [whitening, setWhitening] = useState(0);
  const [faceSlimming, setFaceSlimming] = useState(0);
  const [rosy, setRosy] = useState(0);
  const [filterFunction, setFilterFunction] = useState('Retro');
  const [oneTouchMakeup, setOneTouchMakeup] = useState(true);
  const [depthOfFieldEffect, setDepthOfFieldEffect] = useState(true);
  const [dynamicStickers, setDynamicStickers] = useState('Retro');
  const [liveType, setLiveType] = useState(0);

  //国际化语言切换
  const { t, i18n } = useTranslation();
//文件类型
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
  // 处理开始直播
  const handleStartLive = () => {
;
    if (!liveTitle) {
      message.error(t('goLiveNow.Liverequired'));
      return;
    }
    // if (!liveTitle) {
    //   message.error('Live Title is required');
    //   return;
    // }
    if (!liveStartTime) {
      message.error(t('goLiveNow.LiveStartTime'));
      return;
    }
    if (!liveEndTime) {
      message.error(t('goLiveNow.LiveEndTime'));
      return;
    }

    if (liveStartTime && liveEndTime && liveStartTime > liveEndTime) {
      message.error(t('goLiveNow.StartBeforeEnd'));
      return;
    }
    // if (!audioSwitch) {
    //   message.error('Audio Switch is required');
    //   return;
    // }
    // if (!videoSwitch) {
    //   message.error('Video Switch is required');
    //   return;
    // }
    // if (!productShowcase) {
    //   message.error('Product Showcase is required');
    //   return;
    // }
    // if (!beautyTool) {
    //   message.error('Beauty Tool is required');
    //   return;
    // }
    // if (!skinSmoothing) {
    //   message.error('Skin Smoothing is required');
    //   return;
    // }
    // if (!whitening) {
    //   message.error('Whitening is required');
    //   return;
    // }
    // if (!faceSlimming) {
    //   message.error('Face Slimming is required');
    //   return;
    // }
    // if (!rosy) {
    //   message.error('Rosy is required');
    //   return;
    // }
    // if (!filterFunction) {
    //   message.error('Filter Function is required');
    //   return;
    // }
    // if (!oneTouchMakeup) {
    //   message.error('One Touch Makeup is required');
    //   return;
    // }
    // if (!depthOfFieldEffect) {
    //   message.error('Depth Of Field Effect is required');
    //   return;
    // }
    if (!Array.isArray(fileList) || fileList.length !== 1 ) {
      message.error(t('goLiveNow.Array'));
      return;
    }
   
    const liveData = {
      liveTitle,
      live_room_cover: fileList[0].url,
      liveStartTime: liveStartTime ? liveStartTime.format('YYYY-MM-DD HH:MM') : '',
      liveEndTime: liveEndTime ? liveEndTime.format('YYYY-MM-DD HH:MM') : '',
      audioSwitch,
      videoSwitch,
      productShowcase,
      live_room_type: liveType,
      beautyTool,
      beautySettings: [{
        skinSmoothing,
        whitening,
        faceSlimming,
        rosy,
        filterFunction,
        oneTouchMakeup,
        depthOfFieldEffect,
        dynamicStickers
      }]
    };
    // 这里可以调用开始直播的API
    liveRoomSaveScheduleLiveRoom(liveData).then(res => { 
      if(res.code === 200){
        navigate(`/goLiveNowVideo?liveid=${res.data.live_room_id}`)
        
      }
    });
    // navigate('/goLiveNowVideo')
  };
  const chooseColumns = [
    {
    title: t('goLiveNow.LiveCoverImage'),
    dataIndex: 'live_room_cover',
    key: 'live_room_cover',
    render: (text: string) => (
        <Image
    width={100}
    src={text}
  />
    ),
  },
  {
    title: t('goLiveNow.LiveTitle'),
    dataIndex: 'live_room_title',
    key: 'live_room_title',
    // render: (val: any, row: any)=> {
    //   let price = ''
    //   if(Array.isArray(row.product_sku_values) && row.product_sku_values.length > 0){
    //     price = row.product_sku_values[0].product_price
    //   }
    //   return price ? `$${price}`: ''
    // }
  },
  {
    title: t('goLiveNow.LiveStartTime'),
    dataIndex: 'live_room_scheduled_start_time',
    key: 'live_room_scheduled_start_time',
    render: (val: any)=>{
      return val ? dayjs(val).format('YYYY/MM/DD HH:mm:ss') : ''
    }
  },
  {
    title: t('goLiveNow.LiveEndTime'),
    dataIndex: 'live_room_scheduled_end_time',
    key: 'live_room_scheduled_end_time',
    render: (val: any)=>{
      return val ? dayjs(val).format('YYYY/MM/DD HH:mm:ss') : ''
    }
  },
  {
    title: t('goLiveNow.LiveStatus'),
    dataIndex: 'live_room_status',
    key: 'live_room_status',
    render: (val: any)=>{
      if(val === 1){
        return <span style={{color: '#2AAD61'}}>{t('goLiveNow.Pending')}</span>
      }else if(val === 2){ 
        return <span style={{color: '#2AAD61'}}>{t('goLiveNow.Ongoing')}</span>
      }else if(val === 3){ 
        return <span style={{color: '#2AAD61'}}>{t('goLiveNow.Completed')}</span>
      }else if(val === -1){ 
        return <span style={{color: '#2AAD61'}}>{t('goLiveNow.Cancelled')}</span>
      }
    }
  },
  {
    title: t('goLiveNow.Operations'),
    dataIndex: 'operataions',
    key: 'operataions',
    render: (val: any, row: any)=>{
      return <>
      <Button onClick={()=>{ 
        navigate(`/goLiveNowVideo?liveid=${row.live_room_id}`)
       }} size="small" >Go Live</Button>
      <Button onClick={()=>{ }} size="small" >{t('goLiveNow.Cancel')}</Button>
      </>
    }
  }
  ];
  const [chooseData,setChooseData] = useState<[]>([]);
    const [pageParams, setPageParams] = useState<any>({
      pageNum:1,
      pageSize:10,
      keyword:'',
      live_room_status:'',
      total:0,
    })
    // 获取直播房间列表
    const getProductLists = async (val?:any)=>{
      let params = val ? val : pageParams
        let res = await liveRoomGetLiveRoomPageList({
                page_num: params.pageNum,
                page_size: params.pageSize,
                keyword: params.keyword?.trim() || '',
                live_room_status: params.live_room_status
              });
      setPageParams({...params,pageNum:res.pageNum,total:res.total})
      setChooseData(res.data)
    }
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
      const onSelectChange = (newSelectedRowKeys: any) => {
      setSelectedRowKeys(newSelectedRowKeys);
    };
  //mounted 和unmounted
  useEffect(() => {
    getProductLists()
    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, []);
  const changeTab = (tab:number)=>{ 
    setTab(tab);
  }
   const token = useAppSelector((state) => state.user.token);
   const [fileList, setFileList] = useState<any[]>([]);
  
     // 添加预览状态变量 附件查看大图配置
     const [previewVisible, setPreviewVisible] = useState(false);
     const [previewImage, setPreviewImage] = useState('');
     const [previewTitle, setPreviewTitle] = useState('');
     //图片上传配置
     const uploadProps: UploadProps = {
       name: 'file',
       action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
       accept: ".png,.jpeg,.jpg,.gif",
       headers: {
         //记得修改
         token: `${token}`,
       },
       listType: 'picture-card',
       maxCount: 1, // 只允许上传五个
       showUploadList: true, // 显示fileList
       fileList: fileList,
       beforeUpload: (file) => {
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          message.error("Image must be smaller than 10MB!");
        }
        return isLt10M; // 返回 false 阻止上传
      },
       onChange(info) {
         //debugger
         // 复制一份文件列表
         const newFileList = [...info.fileList];
   
         // 对文件状态进行处理
         newFileList.forEach(file => {
           if (file.response) {
             // 可以从响应中获取文件URL
             file.url = file?.response?.data?.url;
           }
         });
   
         // 更新状态
         setFileList(newFileList);
   
         if (info.file.status !== 'uploading') {
           console.log(info.file, info.fileList);
         }
   
         if (info.file.status === 'done') {
           //完成逻辑
           // setFileList([...fileList, info.file]);
   
         } else if (info.file.status === 'removed') {
           //删除逻辑
           
           setFileList([...info.fileList]);
   
         } else if (info.file.status === 'error') {
  
           message.error(`${info.file.name} file upload failed.`);
  
         }
       },
       async onPreview(file: UploadFile) {
         //预览逻辑
         let src = file.url as string;
         if (!src) {
           src = await new Promise((resolve) => {
             const reader = new FileReader();
             reader.readAsDataURL(file.originFileObj as FileType);
             reader.onload = () => resolve(reader.result as string);
           });
         }
         // 设置预览状态
         setPreviewImage(src);
         setPreviewVisible(true);
         setPreviewTitle(file.name || '图片预览');
       }
     };

  return (
    <>
    <div className={styles['live-tab']}>
      <Button type={tab === 0 ? "primary" : 'default'} onClick={()=> changeTab(0)}>
        {t('goLiveNow.GoLive')}
      </Button>
      <Button type={tab === 1 ? 'primary' : "default"} onClick={()=> changeTab(1)}>
       {t('goLiveNow.ScheduledLive')}
      </Button>
    </div>
      {tab === 0 ? <div className={styles['go-live-now-container']}>
        <div className={styles['live-Title']}>
          {t('goLiveNow.YourLive')}
        </div>
        <div className={styles['search-params']}>
          <span onClick={()=>{
              getProductLists({...pageParams,live_room_status:''})
          }} className={pageParams.live_room_status === '' ? styles['active'] : ''}>{t('goLiveNow.All')}</span>
          <span onClick={()=>{
            getProductLists({...pageParams,live_room_status:1})
          }} className={pageParams.live_room_status === 1 ? styles['active'] : ''}>{t('goLiveNow.Pending')}</span>
          <span onClick={()=>{
            getProductLists({...pageParams,live_room_status:-1})
          }} className={pageParams.live_room_status === -1 ? styles['active'] : ''}>{t('goLiveNow.Cancelled')}</span>
          <span onClick={()=>{
            getProductLists({...pageParams,live_room_status:2})
          }} className={pageParams.live_room_status === 2 ? styles['active'] : ''}>{t('goLiveNow.Ongoing')}</span>
          <span onClick={()=>{
            getProductLists({...pageParams,live_room_status:3})
          }} className={pageParams.live_room_status === 3 ? styles['active'] : ''}>{t('goLiveNow.Completed')}</span>
        </div>
        <Input.Search onSearch={()=>{
          getProductLists()
        }} onChange={(val)=>{
          setPageParams({...pageParams, keyword: val.target.value})
        }} value={pageParams.keyword} placeholder={t('goLiveNow.WarmBreadSweetMoments')} variant="filled" style={{ width: "300px",marginBottom:"20px" }} />
        <Table dataSource={chooseData} columns={chooseColumns} pagination={{total:pageParams.total,pageSize:pageParams.pageSize,onChange(page,pageSize){
            // console.log(chooseForm.getFieldValue('Category'))
            setPageParams((val:any)=>{
              getProductLists()
              return {...val, pageNum:page}
            })
            getProductLists()
          }}} />
      </div>:<div className={styles['go-live-container']}>
      <div className={styles['live-form']}>
        {/* Live Stream Type */}
          <div className={styles['switch-item']} style={{display: "grid", gridTemplateColumns: "130px 1fr", paddingBottom: "23px"}}>
            <span className={styles['switch-label']} style={{width:'200px'}}>{t('goLiveNow.LiveStreamType')}</span>
            <Select value={liveType} onChange={(value) => { setLiveType(value)
            }}>
              <Select.Option value={0}>Sales Live</Select.Option>
              <Select.Option value={1}>Store Live</Select.Option>
            </Select>
          </div>
        {/* Live Time Slot */}
        <div className={styles['form-section']}>
          <h3 className={styles['section-title']}>{t('goLiveNow.LiveTimeSlot')}</h3>
          <div className={styles['time-slot-container']}>
            <div className={styles['time-input-group']}>
              <label className={styles['time-label']}>{t('goLiveNow.StartTime')}</label>
              <DatePicker
                showTime={{ format: 'h:mm A' }}
                format="MM/DD/YYYY h:mm A"
                value={liveStartTime}
                onChange={(date) => setLiveStartTime(date)}
                className={styles['time-input']}
                placeholder="Select start time"
              />
            </div>
            <div className={styles['time-input-group']}>
              <label className={styles['time-label']}>{t('goLiveNow.EndTime')}</label>
              <DatePicker
                showTime={{ format: 'h:mm A' }}
                format="MM/DD/YYYY h:mm A"
                value={liveEndTime}
                onChange={(date) => setLiveEndTime(date)}
                className={styles['time-input']}
                placeholder="Select end time"
              />
            </div>
          </div>
        </div>
        {/* Live Title */}
        <div className={styles['form-section']}>
          <h3 className={styles['section-title']}>{t('goLiveNow.LiveTitle')}</h3>
          <div className={styles['title-input-container']}>
            <Input
              value={liveTitle}
              onChange={(e) => setLiveTitle(e.target.value)}
              className={styles['title-input']}
              placeholder="Live Title"
            />
            <span className={styles['char-count']}>{liveTitle.length}{t('goLiveNow.Number')}</span>
          </div>
        </div>
        <div>
          <label className={styles['switch-label']}>{t('goLiveNow.LiveCoverImage')}</label>
            <Upload {...uploadProps}>
              Upload
            </Upload>
        </div>
        {/* Switches Section */}
        <div className={styles['switches-container']}>
          {/* Audio Switch */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>{t('goLiveNow.AudioSwitch')}</span>
            <Radio.Group
              value={audioSwitch ? 'On' : 'Off'}
              onChange={(e) => setAudioSwitch(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>{t('goLiveNow.On')}</Radio>
              <Radio value="Off" className={styles['radio-option']}>{t('goLiveNow.Off')}</Radio>
            </Radio.Group>
          </div>

          {/* Video Switch */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>{t('goLiveNow.VideoSwitch')}</span>
            <Radio.Group
              value={videoSwitch ? 'On' : 'Off'}
              onChange={(e) => setVideoSwitch(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>{t('goLiveNow.On')}</Radio>
              <Radio value="Off" className={styles['radio-option']}>{t('goLiveNow.Off')}</Radio>
            </Radio.Group>
          </div>

          {/* Product Showcase */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>{t('goLiveNow.ProductShowcase')}</span>
            <Radio.Group
              value={productShowcase ? 'On' : 'Off'}
              onChange={(e) => setProductShowcase(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>{t('goLiveNow.On')}</Radio>
              <Radio value="Off" className={styles['radio-option']}>{t('goLiveNow.Off')}</Radio>
            </Radio.Group>
          </div>

          {/* Beauty Tool */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>{t('goLiveNow.BeautyTool')}</span>
            <Radio.Group
              value={beautyTool ? 'On' : 'Off'}
              onChange={(e) => setBeautyTool(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>{t('goLiveNow.On')}</Radio>
              <Radio value="Off" className={styles['radio-option']}>{t('goLiveNow.Off')}</Radio>
            </Radio.Group>
          </div>
        </div>

        {/* Beauty Tool Settings */}
        {beautyTool && (
          <div className={styles['beauty-section']}>
            <h4 className={styles['beauty-title']}>{t('goLiveNow.BasicBeautyFunctions')}</h4>
            
            <div className={styles['beauty-controls']}>
              <div className={styles['beauty-control-group']}>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>{t('goLiveNow.SkinSmoothing')}</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={skinSmoothing}
                    onChange={(value) => setSkinSmoothing(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>{t('goLiveNow.Whitening')}</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={whitening}
                    onChange={(value) => setWhitening(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>{t('goLiveNow.FaceSlimming')}</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={faceSlimming}
                    onChange={(value) => setFaceSlimming(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
              </div>

              <div className={styles['beauty-control-group']}>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>{t('goLiveNow.Rosy')}</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={rosy}
                    onChange={(value) => setRosy(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>{t('goLiveNow.FilterFunctions')}</label>
                  <Select
                    value={filterFunction}
                    onChange={setFilterFunction}
                    className={styles['select-input']}
                    options={[
                      { value: 'Retro', label: 'Retro' },
                      { value: 'Vintage', label: 'Vintage' },
                      { value: 'Natural', label: 'Natural' },
                    ]}
                  />
                </div>
                <div className={styles['control-item']}>
                  {/* 占位符，保持布局对称 */}
                </div>
              </div>
            </div>

            <h4 className={styles['beauty-title']}>{t('goLiveNow.OtherFunctions')}</h4>
            <div className={styles['other-functions']}>
              <div className={styles['function-item']}>
                <span className={styles['function-label']}>{t('goLiveNow.OneTouchMakeup')}</span>
                <Radio.Group
                  value={oneTouchMakeup ? 'On' : 'Off'}
                  onChange={(e) => setOneTouchMakeup(e.target.value === 'On')}
                  className={styles['radio-group']}
                >
                  <Radio value="On" className={styles['radio-option']}>{t('goLiveNow.On')}</Radio>
                  <Radio value="Off" className={styles['radio-option']}>{t('goLiveNow.Off')}</Radio>
                </Radio.Group>
              </div>

              <div className={styles['function-item']}>
                <span className={styles['function-label']}>{t('goLiveNow.DepthOfFieldEffect')}</span>
                <Radio.Group
                  value={depthOfFieldEffect ? 'On' : 'Off'}
                  onChange={(e) => setDepthOfFieldEffect(e.target.value === 'On')}
                  className={styles['radio-group']}
                >
                  <Radio value="On" className={styles['radio-option']}>{t('goLiveNow.On')}</Radio>
                  <Radio value="Off" className={styles['radio-option']}>{t('goLiveNow.Off')}</Radio>
                </Radio.Group>
              </div>

              <div className={styles['function-item']}>
                <span className={styles['function-label']}>{t('goLiveNow.DynamicStickers')}</span>
                <Select
                  value={dynamicStickers}
                  onChange={setDynamicStickers}
                  className={styles['select-input']}
                  options={[
                    { value: 'Retro', label: 'Retro' },
                    { value: 'Cute', label: 'Cute' },
                    { value: 'Cool', label: 'Cool' },
                  ]}
                />
              </div>
            </div>
          </div>
        )}

        {/* Start Live Button */}
        <div className={styles['start-live-section']}>
          <Button
            type="primary"
            size="large"
            onClick={handleStartLive}
            className={styles['start-live-button']}
          >
            {t('goLiveNow.StartLiveNow')}
          </Button>
        </div>
      </div>

      {/* Right side - Preview */}
      <div className={styles['preview-section']}>
        <img className='w-full h-auto' src={liveIcon1} alt="liveIcon1" />
      </div>
    </div>}
    {/* 添加预览Modal */}
    <Modal
      open={previewVisible}
      title={previewTitle}
      width={"80%"}
      footer={null}
      onCancel={() => setPreviewVisible(false)}
    >
      <img alt={previewTitle} style={{ width: '100%' }} src={previewImage} />
    </Modal>
    </>
  );
};

export default GoLiveNow; 

